import { combineReducers } from 'redux';
import { SocialGoogleAuth } from './SocialGoogleAuth';

export const SocialAuthReducer = combineReducers({
  google: SocialGoogleAuth,
});

export type SocialAuthState = ReturnType<typeof SocialAuthReducer>;
